import React from 'react';
import { Link } from 'react-router-dom';

const Blogs = () => {
  return (
    <div>
      <h1>Ice blogs</h1>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/IcebergerSafety2026.png" alt="History blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/iceberger-safety-2026">
              IceBerger Safety 2026 Presentation 
            </Link>
            <span> 1/6/2026</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/PreSwimPersonalRiskAssessment.jpg" alt="History blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/PreSwimPersonalRiskAssessment">
              Pre-Swim Personal Risk Assessment & Safety Checklist
            </Link>
            <span> 1/6/26</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/history-of-brighton-blog.jpg" alt="History blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/history-of-temperature-takers">
              History of Brighton Icebergers water temperature takers
            </Link>
            <span> 10/7/23</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/beyond-the-tip-blog.jpg" alt="Beyond the Tip blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/beyond-the-tip">
              Beyond the Tip
            </Link>
            <span> 23/5/19</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/where-we-swim-blog.jpg" alt="Where We Swim blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/where-we-swim">
              Where we swim
            </Link>
            <span> 25/4/19</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/hypothermia-blog.png" alt="Hypothermia blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/hypothermia">
              HYPOTHERMIA
            </Link>
            <span> 12/3/19</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/resuscitation-blog.jpg" alt="Resuscitation and Rescue blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/resuscitation-and-rescue">
              Resuscitation and Rescue
            </Link>
            <span> 11/12/18</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/safety-gear-blog.jpg" alt="Safety Gear blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/safety-gear">
              Safety Gear
            </Link>
            <span> 2/12/18</span>
          </div>
        </li>
        <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/images/and-those-feet-blog.jpeg" alt="And did those feet blog" style={{ width: '60px', height: '60px', objectFit: 'contain', objectPosition: 'center' }} />
          <div>
            <Link to="/blogs/and-did-those-feet">
              "And did those feet...
            </Link>
            <span> 25/10/18</span>
          </div>
        </li>
      </ul>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default Blogs;
